module.exports = __webpack_public_path__ + "static/media/message.b6c4e469.mp3";